module.exports = __webpack_public_path__ + "public/Icons/batch-icon3.png?fbdfbf94";